import React from 'react';
import ProgressBar from '../../Progress';

const SkillsProgress = ({
  python, cpp, ros, sim, ml, cad, matlab, embedded,
}) => (
  <div>
    {python && <ProgressBar percent={parseInt(python, 10)} text="Python" />}
    {cpp && <ProgressBar percent={parseInt(cpp, 10)} text="C++" />}
    {ros && <ProgressBar percent={parseInt(ros, 10)} text="ROS / ROS 2" />}
    {sim && <ProgressBar percent={parseInt(sim, 10)} text="Gazebo / Sim" />}
    {ml && <ProgressBar percent={parseInt(ml, 10)} text="ML (RL / CV)" />}
    {cad && <ProgressBar percent={parseInt(cad, 10)} text="CAD" />}
    {matlab && <ProgressBar percent={parseInt(matlab, 10)} text="MATLAB" />}
    {embedded && <ProgressBar percent={parseInt(embedded, 10)} text="Embedded" />}
  </div>
);

export default SkillsProgress;
